export type ExecutionModel = "spot" | "futures";
export type DerivativesCapabilityState = boolean | null;

export interface DerivativesCapabilityPayload {
  enabled?: boolean;
  schema_version?: number;
  execution_models?: readonly string[];
}

export const DEFAULT_EXECUTION_SETTINGS = Object.freeze({
  executionModel: "futures" as const,
  marginMode: "isolated" as const,
  leverage: 10,
});

export function shouldOfferFutures(capability: DerivativesCapabilityState): boolean {
  return capability !== false;
}

export function shouldFallbackToSpot(
  capability: DerivativesCapabilityState,
  executionModel: ExecutionModel,
): boolean {
  return capability === false && executionModel === "futures";
}

/**
 * Treat an explicit server rejection, or a supported schema that omits
 * Futures, as unsupported. A missing payload, unknown schema, or incomplete
 * response must not silently replace the Futures-first setup while
 * capabilities are loading or temporarily offline.
 */
export function resolveDerivativesCapability(
  capability: DerivativesCapabilityPayload | null | undefined,
): DerivativesCapabilityState {
  if (capability?.enabled === false) return false;
  if (
    capability?.enabled !== true
    || capability.schema_version !== 1
    || !Array.isArray(capability.execution_models)
  ) {
    return null;
  }
  return capability.execution_models.includes("futures");
}
